import { Head } from "components/Head";
import { MainLayout } from "components/Layout";
import { useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";
import { BannerCarousel } from "../components/BannerCarousel";
import { Counter } from "../components/Counter";
import { DownloadsResources } from "../components/DownloadsResources";
import { LatestNews } from "../components/LatestNews";
import { Partners } from "../components/Partners";
import { RegisterAlumni } from "../components/RegisterAlumni";
import { UpcomingEvents } from "../components/UpcomingEvents";
import { UBTEBLinks } from "../components/UBTEBLinks";
import { QuickLinks } from "../components/QuickLinks";
import { Typography } from "components/Elements";
import { NewsLetter } from "../components/NewsLetter";

export const Landing = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <MainLayout title="Home">
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        cookieName="ubtebCookieConsent"
        style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
        buttonStyle={{ color: "#4e503b", fontSize: "12px" }}
        expires={150}
      >
        We use cookies and other identifiers to help improve your online
        experience. By using our website you are agreeing to this. Read our{" "}
        <Link to="/privacy-policy"> privacy policy</Link> to find out what
        cookies are used for and how to change your settings.
      </CookieConsent>
      <Head description="Home" />

      <section id="banner">
        <div className="mx-auto flex flex-col gap-4 px-4 md:px-8 mt-0 md:mt-5 space-y-2 md:space-y-0 md:flex-row">
          <div className="w-full md:w-2/3">
            <BannerCarousel />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
              <Link
                to="/programmes/modular"
                className="bg-white border hover:bg-red-100 shadow-lg rounded-md p-5"
              >
                <Typography
                  variant="danger"
                  fontCase="upper"
                  size="sm"
                  className="font-bold"
                >
                  Modular Programmes
                </Typography>
                <p className="mt-2 text-gray-700">
                  Discover the future of learning with our innovative Modular
                  Programmes.
                </p>
              </Link>

              <Link
                to="/programmes/semester"
                className="bg-white border hover:bg-red-100 shadow-lg rounded-md p-5"
              >
                <Typography
                  variant="danger"
                  fontCase="upper"
                  size="sm"
                  className="font-bold"
                >
                  Semester Based Programmes
                </Typography>
                <p className="mt-2 text-gray-700">
                  Embark on a journey of academic excellence with our Semester Based
                  Programmes.
                </p>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 w-full md:w-1/3">
            <LatestNews />
            <QuickLinks />
          </div>
        </div>
      </section>
      <div className="bg-blue-800 my-5 py-2">
        <Counter />
      </div>
      <div className="mx-2 md:mx-10 grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="md:col-span-2">
          <UBTEBLinks />
        </div>
        <DownloadsResources />
        <UpcomingEvents />
      </div>
      <RegisterAlumni />
      <Partners />
      <NewsLetter />
    </MainLayout>
  );
};
